<mg-ui-timedloader *ngIf="!user"></mg-ui-timedloader>

<ng-container *ngIf="user">
    <div *ngIf="onfidoStatus === 'clear' && forceCheck !== true" class="check-completed">
        <h2 i18n="@@account.contract-flow.identity.success-title">Your check was completed successfully!</h2>
        <p i18n="@@account.contract-flow.identity.success-text">
            No action is currently needed. Did something change in your circumstances? Please redo the check.
        </p>
        <mg-ui-button (click)="forceCheck = true" i18n="@@account.contract-flow.identity.redo-button"
            >Redo check</mg-ui-button
        >
    </div>

    <ng-container *ngIf="onfidoStatus === 'rejected' && forceCheck !== true">
        <h1 i18n="@@account.contract-flow.identity.failed-title">The check was not successfull</h1>
        <p i18n="@@account.contract-flow.identity.failed-text">
            Please redo the check, by clicking on the button below
        </p>
        <mg-ui-button (click)="forceCheck = true" i18n="@@account.contract-flow.identity.redo-button"
            >Redo check</mg-ui-button
        >
    </ng-container>

    <mg-ui-stepper
        #stepper
        [activeIndex]="onfidoStatus === 'awaiting_result' ? 2 : 0"
        *ngIf="onfidoStatus === 'no_check_started' || onfidoStatus === 'awaiting_result' || forceCheck"
    >
        <mg-ui-stepper-step
            label="Personal details"
            i18n-label="@@account.contract-flow.identity.personal-details-title"
        >
            <h2 i18n="@@account.contract-flow.identity.personal-details-title">Personal details</h2>
            <p i18n="@@account.contract-flow.identity.personal-details-text">
                Please check whether these details match the ones on your driver's license. If necessary, adjust the
                details, and proceed to the next step.
            </p>

            <form (submit)="onUserProfileSave()">
                <mg-deal-user-profile
                    [displayLegalFirstNames]="true"
                    [displayPhonenumber]="true"
                    [displayAddress]="true"
                    [isEditing]="true"
                    #userProfile
                ></mg-deal-user-profile>
                <mg-ui-button
                    [disabled]="!userProfile.valid"
                    [isLoading]="isSavingUserProfile"
                    type="submit"
                    class="main-button"
                    i18n="@@account.contract-flow.identity.personal-details-button"
                    >These details are correct</mg-ui-button
                >
            </form>
        </mg-ui-stepper-step>

        <mg-ui-stepper-step
            #onfidoStep
            label="Driver's license check"
            i18n-label="@@account.contract-flow.identity.check-label"
        >
            <mg-deal-onfido *ngIf="onfidoStep.isActive" (complete)="onOnfidoComplete()"></mg-deal-onfido>
        </mg-ui-stepper-step>

        <mg-ui-stepper-step #finalStep class="final-step">
            <h2 i18n="@@account.contract-flow.identity.success-message.title">Success!</h2>
            <p i18n="@@account.contract-flow.identity.success-message.text">
                All data has been received successfully. We're currently doing the necessary checks.
            </p>
            <mg-visual-great-success *ngIf="finalStep.isActive"></mg-visual-great-success>
        </mg-ui-stepper-step>
    </mg-ui-stepper>
</ng-container>
